module.exports = __webpack_public_path__ + "static/media/icon_location_order.4cc8d6fc.svg";